export default {
      id: "command__sign_in_admin-usage",
      viewBox: "0 0 82.7 70.2",
      url: __webpack_public_path__ + "img/icons.svg#command__sign_in_admin",
      toString: function () {
        return this.url;
      }
    }